"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// MIT © 2017 azu
var RepositoryCore_1 = require("./RepositoryCore");
var map_like_1 = require("map-like");
/**
 * NullableRepository has not initial value.
 * In other word, NullableRepository#get may return undefined.
 */
var NullableRepository = /** @class */ (function () {
    function NullableRepository() {
        this.core = new RepositoryCore_1.RepositoryCore(new map_like_1.MapLike());
    }
    Object.defineProperty(NullableRepository.prototype, "map", {
        get: function () {
            return this.core.map;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NullableRepository.prototype, "events", {
        get: function () {
            return this.core.events;
        },
        enumerable: true,
        configurable: true
    });
    NullableRepository.prototype.get = function () {
        return this.core.getLastSaved();
    };
    NullableRepository.prototype.getAll = function () {
        return this.core.getAll();
    };
    NullableRepository.prototype.findById = function (entityId) {
        return this.core.findById(entityId);
    };
    NullableRepository.prototype.save = function (entity) {
        this.core.save(entity);
    };
    NullableRepository.prototype.delete = function (entity) {
        this.core.delete(entity);
    };
    NullableRepository.prototype.clear = function () {
        this.core.clear();
    };
    return NullableRepository;
}());
exports.NullableRepository = NullableRepository;
//# sourceMappingURL=NullableRepository.js.map